import api from 'Application/api/api';

const getEmployeesWithoutDriverLicenseControl = (load, cancelToken = null) =>
    api.get('/employees/without-driver-license-control', {
        params: {
            load,
        },
        cancelToken,
    });

export default getEmployeesWithoutDriverLicenseControl;
